import { DatePipe } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { StateMasterModel } from 'src/Models/stateMasterModel';
import { TRFAContentGetModelV2 } from 'src/Models/TRFAContentModel';
import { TRFAFundModel } from 'src/Models/TRFAFundModel';
import { TRFASourceModel } from 'src/Models/TRFASourceModel';
import { StateMasterService } from 'src/Services/state-master.service';
import { TrfaCarrierMasterService } from 'src/Services/trfa-carrier--master.service';
import { TrfaCategoryMasterService } from 'src/Services/trfa-category-master.service';
import { TrfaContentMasterService } from 'src/Services/trfa-content-master.service';
import { TrfaFundMasterService } from 'src/Services/trfa-fund-master.service';
import { TrfaMonthsService } from 'src/Services/trfa-months.service';
import { TrfaSourceMasterService } from 'src/Services/trfa-source-master.service';
import { CheckAuth } from 'src/Services/utility.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.css']
})
export class ContentListComponent implements OnInit {
  ckeConfig: any;
  stateCode: any;
  tokenKey: string = '';
  listofContent: TRFAContentGetModelV2[] = [];
  listofContentExport: TRFAContentGetModelV2[] = [];
  templistofContent: TRFAContentGetModelV2[];

  PageNumber: number = 1;
  PageSize: number;
  WhereCondition: string;
  OrderBy: string;
  Note: string;


  upDowRuleTextCSS: string = '';
  upDowStateNameCSS: string = '';
  upDowFundNameCSS: string = '';
  upDowCategoryNameCSS: string = '';
  upDowSourceNameCSS: string = '';

  isAscending: boolean = false;
  isRecord: boolean = false;
  isloading: boolean = false;
  SelectedTool: string;
  totalRecordCount: number = 0;

  //State List
  dropdownListState: any[] = [];
  selectedItemsState: any[] = [];
  dropdownSettingsState = {};
  listOfStateIds: any[] = [];
  stateId: string = ' ';
  stateList: StateMasterModel[] = [];

  //Fund
  fundID: string = ' ';
  dropdownListFund: any[] = [];
  selectedItemsFund: any[] = [];
  dropdownSettingsFund = {};
  listOffundIDs: any[] = [];
  fundList: TRFAFundModel[] = [];

  EditfundID: string = ' ';
  EditdropdownListFund: any[] = [];
  EditselectedItemsFund: any[] = [];
  EditdropdownSettingsFund = {};
  EditlistOffundIDs: any[] = [];
  EditfundList: TRFAFundModel[] = [];
  EditlistOfFundName: any[] = [];


  module = "TRFA";
  stateIds: string = ' ';
  contentData: any;

  //Source
  SourceList: TRFASourceModel[] = [];
  selectedItemsSource: any[] = [];
  dropdownListSource: any[] = [];
  dropdownSettingsSource = {};
  listOfsource: any[] = [];
  sourceTypeId: string = '';

  //Edited Source
  EditSourceList: TRFASourceModel[] = [];
  EditselectedItemsSource: any[] = [];
  EditdropdownListSource: any[] = [];
  EditdropdownSettingsSource = {};
  EditlistOfsource: any[] = [];
  EditsourceTypeId: string = '';
  EditlistOfsourceName: any[] = [];

  MonthList: any[] = [];
  selectedItemsMonth: any[] = [];
  dropdownSettingsMonthFilter = {};
  dropdownMonthFilter: any[] = [];
  auditMonth: any;
  listOfMonth: any[] = [];

  MonthList1: any[] = [];
  selectedItemsMonth1: any[] = [];
  dropdownSettingsMonthFilter1 = {};
  dropdownMonthFilter1: any[] = [];
  listOfMonth1: any[] = [];

  carrierList: any[] = [];
  dropdownDateCarrierFilter: any[] = [];
  dropdownSettingsDateCarrierFilter = {};
  selectedItemsCarrier: any[] = [];
  listOfCarrierIDs: any[] = [];
  listOfCarrierName: any[] = [];

  categoryList: any[] = [];
  dropdownDateCategoryFilter: any[] = [];
  dropdownSettingsDateCategoryFilter = {};
  selectedItemsCategory: any[] = [];
  listOfCategoryIDs: any[] = [];
  listOfCategoryName: any[] = [];


  categoryListMain: any[] = [];
  dropdownDateCategoryFilterMain: any[] = [];
  dropdownSettingsDateCategoryFilterMain = {};
  selectedItemsCategoryMain: any[] = [];
  listOfCategoryIDsMain: any[] = [];
  categoryId: string = '';

  isRowEdited = false;
  changedata: any;
  isSaveData: boolean = false;
  ContentId: number = 0;
  userID: any;

  openMenuIndex: number = -1;

  constructor(private readonly router: Router,
    private readonly trfaContentMaster: TrfaContentMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private readonly stateService: StateMasterService,
    private readonly trfaFundMaster: TrfaFundMasterService,
    private readonly carrierMasterService: TrfaCarrierMasterService,
    private readonly categoryMasterService: TrfaCategoryMasterService,
    private readonly ContentService: TrfaContentMasterService,
    private readonly datePipe: DatePipe,
    private readonly trfaSourceMaster: TrfaSourceMasterService,
    private readonly trfaMonthsService: TrfaMonthsService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.listofContent = [];
    this.templistofContent = [];
    this.PageNumber = 1;
    this.PageSize = 10;
    this.WhereCondition = 'null';
    this.OrderBy = 'StateName,FundName';
    this.Note = 'null';
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.titleService.setTitle('Audit Window');
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.ckeConfig = {
      versionCheck: false,
      toolbar: [
        {
          items:
            [
              'Undo', 'Redo', 'Link', 'Unlink', 'Anchor',
              'Image', 'Table', 'SpecialChar', 'Maximize', 'Source', 'Bold', 'Italic', 'Underline', 'Strike', 'RemoveFormat',
              'NumberedList', 'BulletedList', 'Outdent', 'Indent', 'Styles', 'Format', 'Font'
            ]
        }],
    }

    this.dropdownSettingsState = {
      singleSelection: false,
      text: "Filter by Jurisdiction",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Jurisdiction(s) available',
      showCheckbox: true
    };
    this.dropdownSettingsFund = {
      singleSelection: false,
      text: "Filter by Fund",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Fund(s) available',
      showCheckbox: true
    };

    this.EditdropdownSettingsFund = {
      singleSelection: true,
      text: "Select Fund",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Fund(s) available',
      showCheckbox: true,
      enableFilterSelectAll: false
    };

    this.dropdownSettingsDateCategoryFilter = {
      singleSelection: true,
      text: "Select category",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No Category(s) available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };

    this.dropdownSettingsDateCategoryFilterMain = {
      singleSelection: false,
      text: "Filter by Category",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Category(s) available',
      showCheckbox: true
    };

    this.dropdownSettingsDateCarrierFilter = {
      singleSelection: false,
      text: "Select carriers",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No Carrier(s) available',
      showCheckbox: true
    };

    this.dropdownSettingsSource = {
      singleSelection: false,
      text: "Filter by Source",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 1,
      noDataLabel: 'No Source(s) available',
      showCheckbox: true
    };

    this.dropdownSettingsMonthFilter = {
      singleSelection: false,
      text: "Select Month",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No Month(s) available',
      showCheckbox: true
    };

    this.dropdownSettingsMonthFilter1 = {
      singleSelection: true,
      text: "Filter by Month",
      enableSearchFilter: true,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 2,
      noDataLabel: 'No Month(s) available',
      showCheckbox: false,
      enableFilterSelectAll: false
    };

    $(function () {
      $('.wrapper1').on('scroll', function (e) {
        $('.wrapper2').scrollLeft($('.wrapper1').scrollLeft());
      });
      $('.wrapper2').on('scroll', function (e) {
        $('.wrapper1').scrollLeft($('.wrapper2').scrollLeft());
      });
      $('.div1').width($('table').width());
      $('.div2').width($('table').width());
    });


    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.userID = this.sessionStorageService.getAdminUserId();
    this.getState();
    this.getFund();
    this.OrderBy = 'StateName,FundName';

    this.getCarrier();
    this.getCategory();
    this.getSource();
    //this.GetEditFund();
    this.getMonths1();
    this.isloading = true;

    setTimeout(() => {
      let trfastateName = sessionStorage.getItem("trfastateName") || '';
      if (trfastateName != "") {
        sessionStorage.removeItem("trfastateName");
        let data = this.dropdownListState.filter(x => x.itemName == trfastateName)[0];
        if (data != null) {
          this.selectedItemsState.push({ "id": data.id, "itemName": data.itemName })

          this.listOfStateIds.push(this.selectedItemsState[0].id);


          let trfafundName = sessionStorage.getItem("trfafundName") || '';

          if (trfafundName != "") {
            sessionStorage.removeItem("trfafundName");
            let dataFund = this.fundList.filter(x => x.fundName == trfafundName && x.stateId == this.selectedItemsState[0].id)[0];
            if (dataFund != null) {
              this.selectedItemsFund.push({ "id": dataFund.fundID, "itemName": dataFund.fundName });
              this.listOffundIDs.push(this.selectedItemsFund[0].id);
            }
          }
        }
      }

      let trfaMonth = sessionStorage.getItem("trfaMonth") || '';
      if (trfaMonth != "") {
        sessionStorage.removeItem("trfaMonth")
        let datatrfaMonth = this.dropdownMonthFilter1.filter(x => x.itemName == trfaMonth)[0];
        if (datatrfaMonth != null) {
          this.selectedItemsMonth1.push({ "id": datatrfaMonth.id, "itemName": datatrfaMonth.itemName });

          this.listOfMonth1.push(this.selectedItemsMonth1[0].itemName);
        }
      }
      this.GetContent();
    }, 4000);
  }

  GetEditFund() {
    this.trfaFundMaster.GetFund(this.tokenKey, this.stateId, true, true).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.EditfundList = result['fund'];
        }
      }
    );
  }

  getFund() {
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.trfaFundMaster.GetFundV2(this.tokenKey, this.stateId, true, true).subscribe(
      data => {
        this.dropdownListFund = []
        this.fundList = data['fund'];
        this.dropdownListFund = data['fund'];
        this.selectedItemsFund = [];
        if (this.fundList.length > 0) {
          let b: any[] = [];
          this.selectedItemsFund = [];
          this.fundList.forEach(x => {
            let a = this.listOffundIDs.filter(e => e == x.fundID);
            if (a.length > 0) {
              b.push(x.fundID);
              this.selectedItemsFund.push(x)
            }
          });
          this.listOffundIDs = b;
        }
        else {
          this.selectedItemsFund = [];
          this.listOffundIDs = [];
        }
      }
    );
  }

  pageChanged($event: any) {
    this.PageNumber = parseInt($event.page);
    this.GetContent();
  }

  getCarrier() {
    this.carrierMasterService.GetCarrierV2(this.tokenKey).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.carrierList = result['carrier'];
          this.dropdownDateCarrierFilter = [];
          this.carrierList.forEach(x => {
            this.dropdownDateCarrierFilter.push({ "id": x.carrierTypeId, "itemName": x.carrierName })
          });
        }
      }
    );
  }

  getCategory() {
    this.categoryMasterService.GetCategoryV2(this.tokenKey).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.categoryList = result['category'];
          this.dropdownDateCategoryFilter = [];

          this.categoryListMain = result['category'];
          this.dropdownDateCategoryFilterMain = [];
          this.categoryList.forEach(x => {
            this.dropdownDateCategoryFilter.push({ "id": x.categoryID, "itemName": x.categoryName })
          });

          this.categoryList.forEach(x => {
            this.dropdownDateCategoryFilterMain.push({ "id": x.categoryID, "itemName": x.categoryName })
          });
        }
      }
    );
  }

  GetContentById(Content: any) {
    this.listofContent.forEach(element => {
      element['isEdit'] = false;
    });
    this.templistofContent = JSON.parse(JSON.stringify(this.listofContent));
    Content.isEdit = true;
    Content.effectiveDate = new Date(Content.effectiveDate);
    if (Content.lastAudit != null) {
      Content.lastAudit = new Date(Content.lastAudit);
    }

    if (this.EditfundList.length == 0) {
      this.GetEditFund();
    }

    if (this.MonthList.length == 0) {
      this.getMonths();
    }

    this.isRowEdited = true;
    this.trfaContentMaster.GetContentById(this.tokenKey, parseInt(Content.contentID.toString())).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (this.carrierList.length > 0) {
            this.selectedItemsCarrier = []
            this.listOfCarrierIDs = [];
            this.listOfCarrierName = [];
            for (let iCounter = 0; iCounter < result['content'].carrierTypeID.length; iCounter++) {
              let data = this.carrierList.filter(x => x.carrierTypeId == result['content'].carrierTypeID[iCounter].carrierTypeId)[0];
              this.selectedItemsCarrier.push({ "id": data.carrierTypeId, "itemName": data.carrierName })
              this.listOfCarrierIDs.push(data.carrierTypeId)
              this.listOfCarrierName.push(data.carrierName)
            }
          }

          if (this.categoryList.length > 0) {
            this.selectedItemsCategory = [];
            this.listOfCategoryIDs = [];
            this.listOfCategoryName = [];
            result['content'].categoryID.map((x) => {
              let data = this.categoryList.filter(y => y.categoryID == x.categoryID)[0];
              this.selectedItemsCategory.push({ "id": data.categoryID, "itemName": data.categoryName })
              this.listOfCategoryIDs.push(data.categoryID)
              this.listOfCategoryName.push(data.categoryName);
            })
          }

          if (this.EditfundList.length > 0) {
            let b = [];
            this.EditlistOffundIDs = [];
            this.EditlistOfFundName = [];
            this.EditselectedItemsFund = [];
            this.EditdropdownListFund = this.EditfundList;
            for (let iCounter = 0; iCounter < this.fundList.length; iCounter++) {
              if (this.fundList[iCounter].fundID == result['content'].fundID) {
                this.EditselectedItemsFund.push(this.fundList[iCounter]);
                b.push(this.fundList[iCounter].fundID);
                this.EditlistOfFundName.push(this.fundList[iCounter].fundName);
              }
            }
            this.EditlistOffundIDs = b;
          }
          else {
            this.EditdropdownListFund = [];
            this.EditselectedItemsFund = [];
            this.EditlistOffundIDs = [];
            this.EditlistOfFundName = [];
          }

          if (this.EditSourceList.length > 0) {
            this.EditselectedItemsSource = []
            this.EditlistOfsource = []
            this.EditlistOfsourceName = []
            for (let iCounter = 0; iCounter < result['content'].sourceTypeId.length; iCounter++) {

              let data = this.EditSourceList.filter(x => x.sourceTypeId == result['content'].sourceTypeId[iCounter].sourceTypeId)[0];
              this.EditselectedItemsSource.push({ "id": data.sourceTypeId, "itemName": data.sourceName })
              this.EditlistOfsource.push(data.sourceTypeId)
              this.EditlistOfsourceName.push(data.sourceName)
            }
          }

          if (this.MonthList.length > 0) {
            let auditMonthList = [];
            if (result['content'].auditMonth != null && result['content'].auditMonth != '') {
              if (result['content'].auditMonth.includes(',')) {
                auditMonthList = result['content'].auditMonth.split(',');
              }
              else if (result['content'].auditMonth !== "") {
                auditMonthList.push(result['content'].auditMonth);
              }
            }

            if (auditMonthList.length > 0) {
              this.listOfMonth = [];
              this.selectedItemsMonth = [];

              for (let iCounter = 0; iCounter < auditMonthList.length; iCounter++) {

                let data = this.MonthList.filter(x => x.name == auditMonthList[iCounter])[0];
                if (data != undefined) {
                  this.selectedItemsMonth.push({ "id": data.id, "itemName": data.name })
                  this.listOfMonth.push(data.name)
                }
              }
            }
          }
        }
      });
  }

  cancelEdit(data: any) {
    data.isEdit = false;
    this.isRowEdited = false;
    this.selectedItemsMonth = [];
    this.EditselectedItemsSource = [];
    this.EditlistOffundIDs = [];
    this.listofContent = this.templistofContent;
  }

  saveContent(item: any) {
    this.saveSession();
    let carrierId = this.listOfCarrierIDs.join(',');
    let categoryId = this.listOfCategoryIDs.join(',');
    let editlistOffundID = this.EditlistOffundIDs.join(',');
    let sourceID = this.EditlistOfsource.join(',');
    let MonthList = this.listOfMonth.join(',');

    if (editlistOffundID == "" || carrierId == "" || categoryId == "" || item.ruleText == "" || item.effectiveDate == "") {
      if (carrierId == "") {
        this.showMessage("Please select carrier", 'warning', 'warning');
      }
      if (categoryId == "") {
        this.showMessage("Please select category", 'warning', 'warning');
      }
      if (item.ruleText == "") {
        this.showMessage("Please Enter ruleText", 'warning', 'warning');
      }
      if (item.effectiveDate == "") {
        this.showMessage("Please select effectivedate", 'warning', 'warning');
      }
      if (editlistOffundID == "") {
        this.showMessage("Please select fund", 'warning', 'warning');
      }
    }
    else {
      this.listOfMonth = [];

      if (item.internalNote == null) {
        item.internalNote = "";
      }
      if (item.ruleCitation == null) {
        item.ruleCitation = "";
      }
      if (item.subcategory == null) {
        item.subcategory = "";
      }

      let formData = new FormData();
      formData.append('contentID', item.contentID);
      formData.append('fundID', item.fundID);
      formData.append('effectiveDate', this.datePipe.transform(item.effectiveDate, 'yyyy-MM-dd hh:mm:ss'));
      formData.append('ruleText', item.ruleText == null ? null : item.ruleText.trim());
      formData.append('ruleCitation', item.ruleCitation == "" ? item.ruleCitation : item.ruleCitation.trim());
      formData.append('internalNote', item.internalNote == "" ? item.internalNote : item.internalNote.trim(),);
      formData.append('subcategory', item.subcategory == "" ? item.subcategory : item.subcategory.trim());
      formData.append('carrierTypeID', carrierId);
      formData.append('categoryID', categoryId);
      formData.append('lastAudit', this.datePipe.transform(item.lastAudit, 'yyyy-MM-dd hh:mm:ss'));
      formData.append('auditMonth', MonthList);
      formData.append('sourceTypeId', sourceID == "" ? "" : sourceID);


      this.ContentService.ContentAddUpdate(this.tokenKey, formData).subscribe(
        result => {
          if (result['status'] == 'Success') {
            if (result['message'] != "") {
              this.showMessage(result['message'], 'Warning', 'warning')
            } else {
              if (item.contentID > 0) {
                this.showMessage('Content Update successfully', 'Success', 'success');
                this.GetContent();
              }
              else
                this.showMessage('Content saved successfully', 'Success', 'success');
              this.router.navigate(['/admin/' + this.SelectedTool + '/content-list']);
            }
          }
          else {
            this.showMessage(result['status'], 'Error', 'error');
          }
        },
        error => {
          this.showMessage(error, 'Error', 'error');
        }
      );
      item.isEdit = false;
      this.isRowEdited = false;
    }
  }

  GetContent() {
    this.isloading = true;
    this.fundID = ' ';
    if (this.listOffundIDs.length > 0) {
      this.fundID = this.listOffundIDs.join(',')
    }
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.sourceTypeId = '';
    if (this.listOfsource.length > 0) {
      this.sourceTypeId = this.listOfsource.join(',')
    }

    this.categoryId = ' ';
    if (this.listOfCategoryIDsMain.length > 0) {
      this.categoryId = this.listOfCategoryIDsMain.join(',')
    }

    this.auditMonth = '';
    if (this.listOfMonth1.length > 0) {
      this.auditMonth = this.listOfMonth1.join(',')
    }

    if (this.Note == "null") this.Note = " ";
    this.trfaContentMaster.GetAllContentV2(this.tokenKey, this.PageNumber, this.PageSize, this.stateId, this.fundID, " ", this.categoryId, this.sourceTypeId, this.OrderBy, this.auditMonth, false).subscribe(
      data => {
        this.isloading = false;

        this.listofContent = [];
        for (let i = 0; i < data['content'].length; i++) {
          let dataValue = data['content'][i];

          let effectiveDate = '';
          if (dataValue.effectiveDate != null && dataValue.effectiveDate != '') {
            let dateObj = new Date(dataValue.effectiveDate);
            let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            effectiveDate = dateObj.toLocaleDateString('en-US', options);
          }

          let lastAudit = '';
          if (dataValue.lastAudit != null && dataValue.lastAudit != '') {
            let dateObj = new Date(dataValue.lastAudit);
            let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            lastAudit = dateObj.toLocaleDateString('en-US', options);
          }

          this.listofContent.push({
            auditMonth: dataValue.auditMonth,
            carrierName: dataValue.carrierName,
            categoryName: dataValue.categoryName,
            contentID: dataValue.contentID,
            effectiveDate: effectiveDate,
            effectiveDates: dataValue.effectiveDates,
            fundID: dataValue.fundID,
            fundName: dataValue.fundName,
            fundTypeName: dataValue.fundTypeName,
            internalNote: dataValue.internalNote,
            isFavorite: dataValue.isFavorite,
            lastAudit: lastAudit,
            note: dataValue.note,
            ruleCitation: dataValue.ruleCitation,
            ruleText: dataValue.ruleText,
            ruleTextupdated: dataValue.ruleTextupdated,
            sourceName: dataValue.sourceName,
            stateID: dataValue.stateID,
            stateName: dataValue.stateName,
            subcategory: dataValue.subcategory,
            totalRecordCount: dataValue.totalRecordCount
          });
        }

        this.listofContent.forEach(element => {
          element['isEdit'] = false;
        });

        if (this.listofContent != null) {
          if (this.listofContent.length == 0) {
            this.isRecord = true;
            this.totalRecordCount = 0;
          }
          else {
            this.isRecord = false;
            this.totalRecordCount = this.listofContent[0].totalRecordCount;
          }
        }
        else {
          this.isRecord = true;
          this.totalRecordCount = 0;
        }
      },
      error => { this.stateCode = error }
    );
  }

  onSelectCarrier($event: any) {
    this.listOfCarrierIDs = this.removeElemetninArray(this.listOfCarrierIDs, $event.id)
    this.listOfCarrierName = this.removeElemetninArray(this.listOfCarrierName, $event.itemName)
    this.listOfCarrierIDs.push($event.id);
    this.listOfCarrierName.push($event.itemName);
  }

  onDeSelectCarrier($event: any) {
    if (this.listOfCarrierIDs != null) {
      if (this.listOfCarrierIDs.length > 0) {
        this.listOfCarrierIDs = this.removeElemetninArray(this.listOfCarrierIDs, $event.id)
      }
    }

    if (this.listOfCarrierName != null) {
      if (this.listOfCarrierName.length > 0) {
        this.listOfCarrierName = this.removeElemetninArray(this.listOfCarrierName, $event.itemName)
      }
    }
  }

  onSelectAllCarrier($event: any) {
    for (const item of $event) {
      if (this.listOfCarrierIDs != null) {
        if (this.listOfCarrierIDs.length > 0) {
          this.listOfCarrierIDs = this.removeElemetninArray(this.listOfCarrierIDs, item.id)
          this.listOfCarrierIDs.push(item.id);
        }
        else {
          this.listOfCarrierIDs.push(item.id);
        }
      }

      if (this.listOfCarrierName != null) {
        if (this.listOfCarrierName.length > 0) {
          this.listOfCarrierName = this.removeElemetninArray(this.listOfCarrierName, item.itemName)
          this.listOfCarrierName.push(item.itemName);
        }
        else {
          this.listOfCarrierName.push(item.itemName);
        }
      }
    }
  }

  onDeSelectAllCarrier() {
    this.listOfCarrierIDs = [];
    this.listOfCarrierName = [];
  }

  onSelectCategory($event: any) {
    this.listOfCategoryIDs = []
    this.listOfCategoryIDs = this.removeElemetninArray(this.listOfCategoryIDs, $event.id)
    this.listOfCategoryIDs.push($event.id);

    this.listOfCategoryName = []
    this.listOfCategoryName = this.removeElemetninArray(this.listOfCategoryName, $event.itemName)
    this.listOfCategoryName.push($event.itemName);
  }

  onDeSelectCategory($event: any) {
    if (this.listOfCategoryIDs != null) {
      if (this.listOfCategoryIDs.length > 0) {
        this.listOfCategoryIDs = this.removeElemetninArray(this.listOfCategoryIDs, $event.id)
      }
    }

    if (this.listOfCategoryName != null) {
      if (this.listOfCategoryName.length > 0) {
        this.listOfCategoryName = this.removeElemetninArray(this.listOfCategoryName, $event.itemName)
      }
    }
  }

  onSelectAllCategory($event: any) {
    this.listOfCategoryIDs = []
    this.listOfCategoryName = [];
    for (const item of $event) {
      if (this.listOfCategoryIDs != null) {
        if (this.listOfCategoryIDs.length > 0) {
          this.listOfCategoryIDs = this.removeElemetninArray(this.listOfCategoryIDs, item.id)
          this.listOfCategoryIDs.push(item.id);
        }
        else {
          this.listOfCategoryIDs.push(item.id);
        }
      }

      if (this.listOfCategoryName != null) {
        if (this.listOfCategoryName.length > 0) {
          this.listOfCategoryName = this.removeElemetninArray(this.listOfCategoryName, item.itemName)
          this.listOfCategoryName.push(item.itemName);
        }
        else {
          this.listOfCategoryName.push(item.itemName);
        }
      }
    }
  }

  onDeSelectAllCategory() {
    this.listOfCategoryIDs = [];
    this.listOfCategoryName = [];
  }

  keywordFilters($event: any) {
    if ($event.target.value != "" && $event.target.value != null)
      this.Note = $event.target.value;
    else
      this.Note = 'null';
    this.resetPageNoandSize();
    this.GetContent();
  }

  sort(sortBy: string) {
    this.upDowRuleTextCSS = '';
    this.upDowStateNameCSS = '';
    this.upDowFundNameCSS = '';
    this.upDowCategoryNameCSS = '';
    this.upDowSourceNameCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';
      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "stateName") {
        this.upDowStateNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "FundName") {
        this.upDowFundNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CategoryName") {
        this.upDowCategoryNameCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sourceName") {
        this.upDowSourceNameCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "stateName") {
        this.upDowStateNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "FundName") {
        this.upDowFundNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CategoryName") {
        this.upDowCategoryNameCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sourceName") {
        this.upDowSourceNameCSS = 'fa fa-arrow-up';
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  addContent() {
    let navigation = '/admin/' + this.SelectedTool + '/content/manage';
    this.router.navigate([navigation]);
  }

  ContentContent(ContentId: any) {
    let navigation = '/admin/' + this.SelectedTool + '/content/manage/' + ContentId;
    this.router.navigate([navigation]);
  }

  setDeleteData(id: any) {
    this.ContentId = id;
  }

  deleteContent(ContentId: any) {
    this.isloading = true;
    this.trfaContentMaster.DeleteContent(this.tokenKey, ContentId).subscribe(
      data => {
        this.isloading = false;
        if (data['status'] == 'Success') {
          this.showMessage("Deleted successfully", 'Success', 'success')
        }
        this.resetPageNoandSize();
        this.GetContent();
      },
      error => { this.stateCode = error }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }

  removeElemetninArray(array: any[], element: any) {
    return array.filter(e => e !== element);
  }

  onSelectState($event: any) {
    this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
    this.listOfStateIds.push($event.id);
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectState($event: any) {
    if (this.listOfStateIds != null) {
      if (this.listOfStateIds.length > 0) {
        this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, $event.id)
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAll($event: any) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectAllState() {
    this.listOfStateIds = [];
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectFund($event: any) {
    this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, $event.id)
    this.listOffundIDs.push($event.id);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectFund($event: any) {
    if (this.listOffundIDs != null) {
      if (this.listOffundIDs.length > 0) {
        this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, $event.id)
      }
    }
    if (this.listOffundIDs.length > 0) {
      this.stateId = this.listOffundIDs.join(',')
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAllFund($event: any) {
    for (const item of $event) {
      if (this.listOffundIDs != null) {
        if (this.listOffundIDs.length > 0) {
          this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, item.id)
          this.listOffundIDs.push(item.id);
        }
        else {
          this.listOffundIDs.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectAllFund() {
    this.listOffundIDs = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  replaceCommaLine(data: any) {
    if (data != '' && data != null) {
      let list = data.split(",").join("<br />")
      return list
    }
  }

  getState() {
    this.stateService.GetStateMaster(this.tokenKey, this.module).subscribe(
      data => {
        this.stateList = data['state'];
        this.dropdownListState = [];
        if (this.stateList.length > 0) {
          this.stateList.forEach(x => {
            this.dropdownListState.push({ "id": x.stateId, "itemName": x.name })
          });
        }
      }
    );
  }

  getSource() {
    this.trfaSourceMaster.GetSource(this.tokenKey).subscribe(
      data => {
        this.SourceList = data['source'];
        this.dropdownListSource = [];

        this.EditSourceList = data['source'];
        this.EditdropdownListSource = [];

        if (this.SourceList.length > 0) {
          this.SourceList.forEach(x => {
            this.dropdownListSource.push({ "id": x.sourceTypeId, "itemName": x.sourceName })
            this.EditdropdownListSource.push({ "id": x.sourceTypeId, "itemName": x.sourceName })
          });
        }
      }
    );
  }

  onSelectSource($event: { id: any; }) {
    this.listOfsource = this.removeElemetninArray(this.listOfsource, $event.id)
    this.listOfsource.push($event.id);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectSource($event: { id: any; }) {
    if (this.listOfsource != null) {
      if (this.listOfsource.length > 0) {
        this.listOfsource = this.removeElemetninArray(this.listOfsource, $event.id)
      }
    }
    if (this.listOfsource.length > 0) {
      this.sourceTypeId = this.listOfsource.join(',')
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectAllSource() {
    this.listOfsource = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAllSource($event: any) {
    for (const item of $event) {
      if (this.listOfsource != null) {
        if (this.listOfsource.length > 0) {
          this.listOfsource = this.removeElemetninArray(this.listOfsource, item.id)
          this.listOfsource.push(item.id);
        }
        else {
          this.listOfsource.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectEditFund($event: { id: any; itemName: any; }) {
    this.EditlistOffundIDs = [];
    this.EditlistOfFundName = [];
    this.EditlistOffundIDs.push($event.id);
    this.EditlistOfFundName.push($event.itemName);
  }

  onDeSelectEditFund($event: { id: any; itemName: any; }) {
    if (this.EditlistOffundIDs != null) {
      if (this.EditlistOffundIDs.length > 0) {
        this.EditlistOffundIDs = this.removeElemetninArray(this.EditlistOffundIDs, $event.id)
      }
    }

    if (this.EditlistOfFundName != null) {
      if (this.EditlistOfFundName.length > 0) {
        this.EditlistOfFundName = this.removeElemetninArray(this.EditlistOfFundName, $event.itemName)
      }
    }
  }

  onSelectAllEditFund($event: any) {
    for (const item of $event) {
      if (this.EditlistOffundIDs != null) {
        if (this.EditlistOffundIDs.length > 0) {
          this.EditlistOffundIDs = this.removeElemetninArray(this.EditlistOffundIDs, item.id)
          this.EditlistOffundIDs.push(item.id);
        }
        else {
          this.EditlistOffundIDs.push(item.id);
        }
      }

      if (this.EditlistOfFundName != null) {
        if (this.EditlistOfFundName.length > 0) {
          this.EditlistOfFundName = this.removeElemetninArray(this.EditlistOfFundName, item.itemName)
          this.EditlistOfFundName.push(item.itemName);
        }
        else {
          this.EditlistOfFundName.push(item.itemName);
        }
      }
    }
  }

  onDeSelectAllEditFund() {
    this.EditlistOffundIDs = [];
    this.EditlistOfFundName = [];
  }

  onSelectEditSource($event: { id: any; itemName: any; }) {
    this.EditlistOfsource = this.removeElemetninArray(this.EditlistOfsource, $event.id)
    this.EditlistOfsource.push($event.id);
    this.EditlistOfsourceName = this.removeElemetninArray(this.EditlistOfsourceName, $event.itemName)
    this.EditlistOfsourceName.push($event.itemName);
  }

  onDeSelectEditSource($event: { id: any; itemName: any; }) {
    if (this.EditlistOfsource != null) {
      if (this.EditlistOfsource.length > 0) {
        this.EditlistOfsource = this.removeElemetninArray(this.EditlistOfsource, $event.id)
      }
    }
    if (this.EditlistOfsource.length > 0) {
      this.EditsourceTypeId = this.EditlistOfsource.join(',')
    }

    if (this.EditlistOfsourceName != null) {
      if (this.EditlistOfsourceName.length > 0) {
        this.EditlistOfsourceName = this.removeElemetninArray(this.EditlistOfsourceName, $event.itemName)
      }
    }
  }

  onDeSelectAllEditSource() {
    this.EditlistOfsource = [];
    this.EditlistOfsourceName = [];
  }

  onSelectAllEditSource($event: any) {
    for (const item of $event) {
      if (this.EditlistOfsource != null) {
        if (this.EditlistOfsource.length > 0) {
          this.EditlistOfsource = this.removeElemetninArray(this.EditlistOfsource, item.id)
          this.EditlistOfsource.push(item.id);
        }
        else {
          this.EditlistOfsource.push(item.id);
        }
      }

      if (this.EditlistOfsourceName != null) {
        if (this.EditlistOfsourceName.length > 0) {
          this.EditlistOfsourceName = this.removeElemetninArray(this.EditlistOfsourceName, item.itemName)
          this.EditlistOfsourceName.push(item.itemName);
        }
        else {
          this.EditlistOfsourceName.push(item.itemName);
        }
      }
    }
  }

  getMonths() {
    this.MonthList = this.trfaMonthsService.getMonths();
    this.dropdownMonthFilter = [];
    this.selectedItemsMonth = [];
    this.MonthList.forEach(x => {
      this.dropdownMonthFilter.push({ "id": x.id, "itemName": x.name })
    });
  }

  onDeSelectMonthAll() {
    this.selectedItemsMonth = [];
    this.listOfMonth = [];
  }

  onSelectMonth($event: { itemName: any; }) {
    this.listOfMonth = this.removeElemetninArray(this.listOfMonth, $event.itemName)
    this.listOfMonth.push($event.itemName);
  }

  onDeSelectMonth($event: { itemName: any; }) {
    if (this.listOfMonth != null) {
      if (this.listOfMonth.length > 0) {
        this.listOfMonth = this.removeElemetninArray(this.listOfMonth, $event.itemName)
      }
    }
  }

  onSelectAllMonth($event: any) {
    for (const item of $event) {
      if (this.listOfMonth != null) {
        if (this.listOfMonth.length > 0) {
          this.listOfMonth = this.removeElemetninArray(this.listOfMonth, item.itemName)
          this.listOfMonth.push(item.itemName);
        }
        else {
          this.listOfMonth.push(item.itemName);
        }
      }
    }
  }

  onSelectCategoryMain($event: { id: any; }) {
    this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, $event.id)
    this.listOfCategoryIDsMain.push($event.id);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectCategoryMain($event: { id: any; }) {
    if (this.listOfCategoryIDsMain != null) {
      if (this.listOfCategoryIDsMain.length > 0) {
        this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, $event.id)
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAllCategoryMain($event: any) {
    this.listOfCategoryIDsMain = []
    for (const item of $event) {
      if (this.listOfCategoryIDsMain != null) {
        if (this.listOfCategoryIDsMain.length > 0) {
          this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, item.id)
          this.listOfCategoryIDsMain.push(item.id);
        }
        else {
          this.listOfCategoryIDsMain.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectAllCategoryMain() {
    this.listOfCategoryIDsMain = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  resetPageNoandSize() {
    this.PageNumber = 1;
    this.PageSize = 10;
  }

  getMonths1() {
    this.MonthList1 = this.trfaMonthsService.getMonths();
    this.dropdownMonthFilter1 = [];
    this.selectedItemsMonth1 = [];
    this.MonthList1.forEach(x => {
      this.dropdownMonthFilter1.push({ "id": x.id, "itemName": x.name })
    });
  }

  onSelectMonth1($event: { itemName: any; }) {
    this.listOfMonth1 = [];
    this.listOfMonth1.push($event.itemName);
    this.resetPageNoandSize();
    this.GetContent();
  }

  onDeSelectMonth1() {
    this.listOfMonth1 = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  onSelectAllMonth1($event: any) {
    for (const item of $event) {
      if (this.listOfMonth1 != null) {
        if (this.listOfMonth1.length > 0) {
          this.listOfMonth1 = this.removeElemetninArray(this.listOfMonth1, item.itemName)
          this.listOfMonth1.push(item.itemName);
        }
        else {
          this.listOfMonth1.push(item.itemName);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();

  }

  onDeSelectMonthAll1() {
    this.listOfMonth1 = [];
    this.resetPageNoandSize();
    this.GetContent();
  }

  saveSession() {
    sessionStorage.setItem('ContentSaveFilterPageNo', this.PageNumber.toString());
    sessionStorage.setItem('ContentSaveFilterOrderBy', this.OrderBy);
    sessionStorage.setItem('ContentSaveFilterIsAscending', this.isAscending ? 'true' : 'false');
    sessionStorage.setItem('ContentSaveFilterFundId', JSON.stringify(this.listOffundIDs));
    sessionStorage.setItem('ContentSaveFilterStateId', JSON.stringify(this.listOfStateIds));
    sessionStorage.setItem('ContentSaveFilterCategoryId', JSON.stringify(this.listOfCategoryIDsMain));
    sessionStorage.setItem('ContentSaveFilterlistOfMonth', JSON.stringify(this.listOfMonth1));
  }

  clearSession() {
    sessionStorage.removeItem('ContentSaveFilterPageNo');
    sessionStorage.removeItem('ContentSaveFilterOrderBy');
    sessionStorage.removeItem('ContentSaveFilterIsAscending');
    sessionStorage.removeItem('ContentSaveFilterFundId');
    sessionStorage.removeItem('ContentSaveFilterStateId');
    sessionStorage.removeItem('ContentSaveFilterCategoryId');
    sessionStorage.removeItem('ContentSaveFilterlistOfMonth');
  }

  setSaveFilter() {
    if (sessionStorage.getItem('ContentSaveFilterPageNo') != null && sessionStorage.getItem('ContentSaveFilterPageNo') != '' && sessionStorage.getItem('ContentSaveFilterPageNo') != 'undefined') {
      this.PageNumber = +sessionStorage.getItem('ContentSaveFilterPageNo');
    }
    if (sessionStorage.getItem('ContentSaveFilterOrderBy') != null && sessionStorage.getItem('ContentSaveFilterOrderBy') != '' && sessionStorage.getItem('ContentSaveFilterOrderBy') != 'undefined') {
      this.OrderBy = sessionStorage.getItem('ContentSaveFilterOrderBy');
    }
    if (sessionStorage.getItem('ContentSaveFilterIsAscending') != null && sessionStorage.getItem('ContentSaveFilterIsAscending') != '' && sessionStorage.getItem('ContentSaveFilterIsAscending') != 'undefined') {
      this.isAscending = sessionStorage.getItem('ContentSaveFilterIsAscending') == 'false' ? false : true;
      if (this.isAscending) {
        this.ContentSessionSort(this.OrderBy.replace('ASC', '').trim());
      } else {
        this.ContentSessionSort(this.OrderBy.replace('DESC', '').trim());
      }
    }
    if (sessionStorage.getItem('ContentSaveFilterFundId') != null && sessionStorage.getItem('ContentSaveFilterFundId') != '' && sessionStorage.getItem('ContentSaveFilterFundId') != 'undefined') {
      this.listOffundIDs = JSON.parse(sessionStorage.getItem('ContentSaveFilterFundId'));
    }
    if (sessionStorage.getItem('ContentSaveFilterStateId') != null && sessionStorage.getItem('ContentSaveFilterStateId') != '' && sessionStorage.getItem('ContentSaveFilterStateId') != 'undefined') {
      this.listOfStateIds = JSON.parse(sessionStorage.getItem('ContentSaveFilterStateId'));
    }
    if (sessionStorage.getItem('ContentSaveFilterCategoryId') != null && sessionStorage.getItem('ContentSaveFilterCategoryId') != '' && sessionStorage.getItem('ContentSaveFilterCategoryId') != 'undefined') {
      this.listOfCategoryIDsMain = JSON.parse(sessionStorage.getItem('ContentSaveFilterCategoryId'));
    }
    if (sessionStorage.getItem('ContentSaveFilterlistOfMonth') != null && sessionStorage.getItem('ContentSaveFilterlistOfMonth') != '' && sessionStorage.getItem('ContentSaveFilterlistOfMonth') != 'undefined') {
      this.listOfMonth1 = JSON.parse(sessionStorage.getItem('ContentSaveFilterlistOfMonth'));
    }

    this.clearSession();
  }

  ContentSessionSort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.OrderBy = sortBy + ' DESC';
      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-down';
        this.upDowStateNameCSS = '';
        this.upDowFundNameCSS = '';
        this.upDowCategoryNameCSS = '';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "stateName") {
        this.upDowRuleTextCSS = '';
        this.upDowStateNameCSS = 'fa fa-arrow-down';
        this.upDowFundNameCSS = '';
        this.upDowCategoryNameCSS = '';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "FundName") {
        this.upDowRuleTextCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowFundNameCSS = 'fa fa-arrow-down';
        this.upDowCategoryNameCSS = '';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "CategoryName") {
        this.upDowRuleTextCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowFundNameCSS = '';
        this.upDowCategoryNameCSS = 'fa fa-arrow-down';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "sourceName")
        this.upDowRuleTextCSS = '';
      this.upDowStateNameCSS = '';
      this.upDowFundNameCSS = '';
      this.upDowCategoryNameCSS = '';
      this.upDowSourceNameCSS = 'fa fa-arrow-down';

    }
    else {
      this.isAscending = false;
      this.OrderBy = sortBy;

      if (sortBy === "RuleText") {
        this.upDowRuleTextCSS = 'fa fa-arrow-up';
        this.upDowStateNameCSS = '';
        this.upDowFundNameCSS = '';
        this.upDowCategoryNameCSS = '';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "stateName") {
        this.upDowRuleTextCSS = '';
        this.upDowStateNameCSS = 'fa fa-arrow-down';
        this.upDowFundNameCSS = '';
        this.upDowCategoryNameCSS = '';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "FundName") {
        this.upDowRuleTextCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowFundNameCSS = 'fa fa-arrow-up';
        this.upDowCategoryNameCSS = '';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "CategoryName") {
        this.upDowRuleTextCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowFundNameCSS = '';
        this.upDowCategoryNameCSS = 'fa fa-arrow-up';
        this.upDowSourceNameCSS = '';
      }
      else if (sortBy === "sourceName") {
        this.upDowRuleTextCSS = '';
        this.upDowStateNameCSS = '';
        this.upDowFundNameCSS = '';
        this.upDowCategoryNameCSS = '';
        this.upDowSourceNameCSS = 'fa fa-arrow-up';
      }

    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterSelectAllState($event: any) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
          this.listOfStateIds.push(item.id);
        }
        else {
          this.listOfStateIds.push(item.id);
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllState($event: any) {
    for (const item of $event) {
      if (this.listOfStateIds != null) {
        if (this.listOfStateIds.length > 0) {
          this.listOfStateIds = this.removeElemetninArray(this.listOfStateIds, item.id)
        }
      }
    }
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.getFund();
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterSelectAllFund($event: any) {
    for (const item of $event) {
      if (this.listOffundIDs != null) {
        if (this.listOffundIDs.length > 0) {
          this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, item.id)
          this.listOffundIDs.push(item.id);
        }
        else {
          this.listOffundIDs.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllFund($event: any) {
    for (const item of $event) {
      if (this.listOffundIDs != null) {
        if (this.listOffundIDs.length > 0) {
          this.listOffundIDs = this.removeElemetninArray(this.listOffundIDs, item.id)
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterSelectAllCategory($event: any) {
    this.listOfCategoryIDsMain = []
    for (const item of $event) {
      if (this.listOfCategoryIDsMain != null) {
        if (this.listOfCategoryIDsMain.length > 0) {
          this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, item.id)
          this.listOfCategoryIDsMain.push(item.id);
        }
        else {
          this.listOfCategoryIDsMain.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllCategory($event: any) {
    this.listOfCategoryIDsMain = []
    for (const item of $event) {
      if (this.listOfCategoryIDsMain != null) {
        if (this.listOfCategoryIDsMain.length > 0) {
          this.listOfCategoryIDsMain = this.removeElemetninArray(this.listOfCategoryIDsMain, item.id)
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterSelectAllMonth($event: any) {
    for (const item of $event) {
      if (this.listOfMonth1 != null) {
        if (this.listOfMonth1.length > 0) {
          this.listOfMonth1 = this.removeElemetninArray(this.listOfMonth1, item.itemName)
          this.listOfMonth1.push(item.itemName);
        }
        else {
          this.listOfMonth1.push(item.itemName);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllMonth($event: any) {
    for (const item of $event) {
      if (this.listOfMonth1 != null) {
        if (this.listOfMonth1.length > 0) {
          this.listOfMonth1 = this.removeElemetninArray(this.listOfMonth1, item.itemName)
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterSelectAllSource($event: any) {
    for (const item of $event) {
      if (this.listOfsource != null) {
        if (this.listOfsource.length > 0) {
          this.listOfsource = this.removeElemetninArray(this.listOfsource, item.id)
          this.listOfsource.push(item.id);
        }
        else {
          this.listOfsource.push(item.id);
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  onFilterDeSelectAllSource($event: any) {
    for (const item of $event) {
      if (this.listOfsource != null) {
        if (this.listOfsource.length > 0) {
          this.listOfsource = this.removeElemetninArray(this.listOfsource, item.id)
        }
      }
    }
    this.resetPageNoandSize();
    this.GetContent();
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportTRFAAuditWindow() {
    this.isloading = true;
    this.listofContentExport = [];
    this.fundID = ' ';
    if (this.listOffundIDs.length > 0) {
      this.fundID = this.listOffundIDs.join(',')
    }
    this.stateId = ' ';
    if (this.listOfStateIds.length > 0) {
      this.stateId = this.listOfStateIds.join(',')
    }
    this.sourceTypeId = '';
    if (this.listOfsource.length > 0) {
      this.sourceTypeId = this.listOfsource.join(',')
    }

    this.categoryId = ' ';
    if (this.listOfCategoryIDsMain.length > 0) {
      this.categoryId = this.listOfCategoryIDsMain.join(',')
    }

    this.auditMonth = '';
    if (this.listOfMonth1.length > 0) {
      this.auditMonth = this.listOfMonth1.join(',')
    }

    if (this.Note == "null") this.Note = " ";
    this.trfaContentMaster.GetAllContentV2(this.tokenKey, this.PageNumber, this.PageSize, this.stateId, this.fundID, " ", this.categoryId, this.sourceTypeId, this.OrderBy, this.auditMonth, true).subscribe(
      data => {

        for (let i = 0; i < data['content'].length; i++) {
          let dataValue = data['content'][i];

          let effectiveDate = '';
          if (dataValue.effectiveDate != null && dataValue.effectiveDate != '') {
            let dateObj = new Date(dataValue.effectiveDate);
            let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            effectiveDate = dateObj.toLocaleDateString('en-US', options);
          }

          let lastAudit = '';
          if (dataValue.lastAudit != null && dataValue.lastAudit != '') {
            let dateObj = new Date(dataValue.lastAudit);
            let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
            lastAudit = dateObj.toLocaleDateString('en-US', options);
          }

          this.listofContentExport.push({
            auditMonth: dataValue.auditMonth,
            carrierName: dataValue.carrierName,
            categoryName: dataValue.categoryName,
            contentID: dataValue.contentID,
            effectiveDate: effectiveDate,
            effectiveDates: dataValue.effectiveDates,
            fundID: dataValue.fundID,
            fundName: dataValue.fundName,
            fundTypeName: dataValue.fundTypeName,
            internalNote: dataValue.internalNote,
            isFavorite: dataValue.isFavorite,
            lastAudit: lastAudit,
            note: dataValue.note,
            ruleCitation: dataValue.ruleCitation,
            ruleText: dataValue.ruleText,
            ruleTextupdated: dataValue.ruleTextupdated,
            sourceName: dataValue.sourceName,
            stateID: dataValue.stateID,
            stateName: dataValue.stateName,
            subcategory: dataValue.subcategory,
            totalRecordCount: dataValue.totalRecordCount
          });
        }

        if (this.listofContentExport.length > 0) {
          setTimeout(() => {
            this.DownloadTRFAAuditWindow();
            this.isloading = false;
          }, 3000);
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadTRFAAuditWindow() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportTRFAAuditWindow';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportTRFAAuditWindow.xls");
  }
}